import { Row } from "antd";
import { quintanaRooFaro } from "../src/assets/images";

const Closed = () => {
  return (
    // <div className="closed">
    // <h1>Sorry, we are closed</h1>
    // </div>
    <div>
      <Row justify={"center"}>
        <img
          src={quintanaRooFaro}
          style={{
            // width: "48%",
            maxWidth: "25%",
          }}
        />
      </Row>
      <Row justify={"center"}>
        <h3>El periodo de inscripción ha concluido.</h3>
      </Row>
    </div>
  );
};

export default Closed;
